import { FC, useState } from "react";
import Container from "react-bootstrap/Container";
import { Navigate } from "react-router-dom";
import { NavigationScreen } from "app/component/screen/NavigationScreen";
import { createReportVersionAccessInformationFileRoute, reportVersionAccessInformationRoute } from "app/route/Routes";
import { useRouteParams } from "app/route/route";
import { RouteBreadcrumbs } from "app/route/RouteBreadcrumbs";
import { CreateReportAccessInformationFileForm } from "app/component/report-access-information-file/CreateReportAccessInformationFileForm.tsx";
import { useReportVersionAccessInformationQuery } from "app/api/graph/types";
import { reportVersionGraphId } from "app/api/graph/helpers";
import { LoadingScreen } from "app/component/screen/LoadingScreen";
import { ErrorScreen } from "app/component/screen/ErrorScreen";

export const CreateReportVersionAccessInformationFileScreen: FC = () => {
    const { reportId, versionId } = useRouteParams(createReportVersionAccessInformationFileRoute);
    const [created, setCreated] = useState(false);

    const { data, loading, error } = useReportVersionAccessInformationQuery({
        variables: { versionId: reportVersionGraphId(versionId) },
    });
    const accessInformation = data?.reportVersion?.accessInformation;

    if (loading) {
        return <LoadingScreen />;
    }
    if (error) {
        return <ErrorScreen title="Error" message={error.message} />;
    }
    if (accessInformation == null) {
        return <ErrorScreen title="Error" message="Not found." />;
    }

    return created ? (
        <Navigate to={reportVersionAccessInformationRoute.build({ reportId, versionId })} />
    ) : (
        <NavigationScreen>
            <Container>
                <RouteBreadcrumbs route={createReportVersionAccessInformationFileRoute} />
                <CreateReportAccessInformationFileForm
                    reportId={reportId}
                    versionId={versionId}
                    accessInformationId={accessInformation._id}
                    onCreate={() => setCreated(true)}
                />
            </Container>
        </NavigationScreen>
    );
};
